import { refreshMidway } from './midwayTokenRetriever';
import { Auth } from "aws-amplify";
import { emptyAuthDetails } from "../Constants";

export interface AuthDetails {
	username: string;
	email: string;
}

export const authenticateAmplify = async () => {
	try {
		// eslint-disable-next-line
		const credentials = await refreshMidway();

		const currentUserInfo = await Auth.currentUserInfo();

		try {
			/**
			 * currentAuthenticated can be used to check if a user is logged in when the page is loaded.
			 * It will throw an error if there is no user logged in
			 * https://aws-amplify.github.io/docs/js/authentication#retrieve-current-authenticated-user
			 */
			await Auth.currentAuthenticatedUser();
			const { attributes } = currentUserInfo;
			const { identities } = attributes;
			const userId = JSON.parse(identities)[0]["userId"];

			let userInfo: AuthDetails = {
				username: userId,
				email: attributes.email
			}

			return userInfo;
		} catch (err) {
			await Auth.federatedSignIn({ customProvider: "MidwayOIDC" })
		}
	} catch (err) {
		// eslint-disable-next-line no-console
		console.error(`Error occured during authentication ${err}`);
	}
	let userInfo: AuthDetails = emptyAuthDetails;
	return userInfo;
};